import { i18n } from '../../i18n';
import { getSavedFilters } from '../../hooks';
import {
  momentTextFormat,
  momentDiffDays,
  showToRoles,
  filterWithUserId,
  formatContainerType,
  exportExcel,
} from '../../utils';
import { containersService } from '../../services';
import { getNotFoundContainers } from './utils';

export const handleExportExcelClick = async ({
  states,
  user,
  filteredStates,
  totalCount,
  sortField,
  sortDirection,
  containerList,
}: any) => {
  const oldFilters = getSavedFilters('belongs-to');
  let fileName = 'CONTAINERS';
  if (oldFilters.yardName) fileName += `__${oldFilters.yardName}`;
  if (oldFilters.clientName) fileName += `__${oldFilters.clientName}`;
  let startDate = states.startDate ? momentTextFormat(states.startDate, user, true) : '';
  let endDate = states.endDate ? momentTextFormat(states.endDate, user, true) : '';

  const { data } = await containersService
    .getAllPreFormatProps({
      params: {
        ...filterWithUserId({ ...filteredStates }, user),
        take: totalCount,
        skip: 0,
        sortField,
        sortDirection,
      },
    })
    .then((res) => (containerList ? getNotFoundContainers(res.data, containerList) : res.data));

  const excelData = data.map((container) => ({
    [i18n.t('label.client')]: showToRoles('adminRead', user)
      ? container.clientYard?.client?.code
      : '',
    [i18n.t('label.containerNumber')]: container.number,
    [i18n.t('label.type')]: formatContainerType(container.type),
    [i18n.t('label.condition')]: container.condition,
    [i18n.t('label.marketStatus')]: container.isHold ? 'on hold' : container.sale?.status,
    [i18n.t('label.status')]:
      container.status === 'GATE_OUT_REQUESTED' && container.gateOut?.status === 'EXPIRED'
        ? 'GATE_OUT_EXPIRED'
        : container.status,
    [i18n.t('label.gateInDate')]: container.gateIn?.completedAt
      ? momentTextFormat(container.gateIn.completedAt, user)
      : '',
    [i18n.t('label.gateOutDate')]: container.gateOut?.completedAt
      ? momentTextFormat(container.gateOut.completedAt, user)
      : '',
    [i18n.t('label.daysInTerminal')]:
      momentDiffDays(container.gateIn?.completedAt, container.gateOut?.completedAt || new Date()) +
      ' ' +
      i18n.t('pages.containers.table.days'),
  }));
  const filters = [
    {
      [i18n.t('label.country')]: states.country,
      [i18n.t('label.city')]: states.city,
      [i18n.t('common.yard')]: oldFilters.yardName ?? '',
      [i18n.t('common.client')]: oldFilters.clientName ?? '',
      [i18n.t('label.containerNumber')]: Array.isArray(states.number)
        ? (states.number as string[]).join(', ')
        : states.number,
      [i18n.t('label.type')]: formatContainerType(states.type),
      [i18n.t('label.condition')]: states.condition,
      [i18n.t('label.status')]: states.status,
      [i18n.t('label.from')]: startDate ?? '',
      [i18n.t('label.to')]: endDate ?? '',
    },
  ];
  const sheets = [
    { data: excelData, sheetName: i18n.t('pages.containers.sheet.containers') },
    { data: filters, sheetName: i18n.t('pages.containers.sheet.filters') },
  ];

  if (startDate || endDate) {
    startDate = startDate || 'start';
    endDate = endDate || momentTextFormat(new Date(), user, true);
    fileName = `${fileName} ${startDate}__${endDate}`;
  }

  exportExcel({ sheets, fileName });
};
